export const faqActions = {
  GET_FAQ_PENDING: 'GET_FAQ_PENDING',
  GET_FAQ_SUCCESS: 'GET_FAQ_SUCCESS',
  GET_FAQ_ERROR: 'GET_FAQ_ERROR',
};
